module.exports = __webpack_public_path__ + "static/media/game_detail_bg.f6a62c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_detail_bg.png
// module id = 491
// module chunks = 38